export default __webpack_public_path__ + "static/media/kaus-map-thumbnail.dc1594d2.jpg";